/* eslint-disable arrow-body-style */

export const findImageContentType = (file: File) => {
  if (file?.type === 'image/png') {
    return 'pngImage';
  }

  return 'jpegImage';
};
